module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/logo-f2e984d04d7b5f42778bccf838c7626d.png";